import React, { createContext } from "react";

export interface JourneyAvailability {
  enabled: boolean;
  disabledReason?: string;
  setAvailability: (info: { enabled: boolean; disabledReason?: string }) => void;
}

export const JourneyAvailabilityContext = createContext<JourneyAvailability>({
  enabled: true,
  disabledReason: "",
  setAvailability: () => {},
});
